export default (timestamp: number): Date => {
  const date = new Date(0);
  date.setUTCSeconds(timestamp);
  return date;
};
